module.exports = __webpack_public_path__ + "media/cp2.b182cdc6.mp4";